import * as Sentry from '@sentry/react';
import { scrubSentryEvent, type ScrubbableEvent } from './lib/sentry-scrubber';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN as string,
    environment: import.meta.env.MODE,

    // Capture 10% of transactions for performance tracing in prod.
    // Set to 1.0 locally via .env.local if you want full tracing.
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

    // Belt-and-braces: SDK default is already false, but make it explicit
    // so a future SDK upgrade cannot silently flip it.
    sendDefaultPii: false,

    integrations: [
      Sentry.browserTracingIntegration(),
      // Session Replay — records UI interactions to reproduce errors.
      // maskAllText + blockAllMedia are ON by default; PHI never leaves the browser.
      Sentry.replayIntegration(),
    ],

    // Capture 10% of sessions, 100% of sessions that had an error.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // PHI scrubber — strips emails, AU phone numbers, Cliniko patient
    // IDs, and sensitive headers from every event before transport.
    // AHPRA + Privacy Act 1988 (APP 6 / APP 8 / APP 11). See
    // ./lib/sentry-scrubber.ts for the redaction policy.
    beforeSend(event) {
      return scrubSentryEvent(event as unknown as ScrubbableEvent) as unknown as typeof event;
    },
    beforeBreadcrumb(breadcrumb) {
      if (!breadcrumb) return breadcrumb;
      const wrapped: ScrubbableEvent = { breadcrumbs: [breadcrumb as { [k: string]: unknown }] };
      const scrubbed = scrubSentryEvent(wrapped).breadcrumbs?.[0];
      return (scrubbed as unknown as typeof breadcrumb) ?? breadcrumb;
    },
  });
}
